module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_shikoku-f63984ed3956f497e48f858cfc4021d2.png";